import { render } from "./Combo.vue?vue&type=template&id=1532f5aa&scoped=true"
import script from "./Combo.vue?vue&type=script&lang=js"
export * from "./Combo.vue?vue&type=script&lang=js"

import "./Combo.vue?vue&type=style&index=0&id=1532f5aa&scoped=true&lang=scss"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1532f5aa"]])

export default __exports__